import styled from "styled-components";
import { Card, CardProps } from "@material-ui/core";
import { selectionBorder } from "styles/utils";

export const CreativeCard = styled(Card)<CardProps & { selected?: boolean; pointer?: boolean }>`
    ${({ selected, theme }) => selectionBorder(theme.shadows[4], selected)}
`;
